import { useEffect } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import img_rond from "../../images/service-electre-illu.svg"

const PageBOAccueil = () => {

  useEffect(() => {
    localStorage.removeItem("IFilterDemandes");
    localStorage.removeItem("IFilterMarquesSearch");
    localStorage.removeItem("IFilterActeursJuridiquesSearch");
    localStorage.removeItem("IFilterComptesBO");  
    localStorage.removeItem("IFilterSocietesBO");
    localStorage.removeItem("IFilterComptes");
    localStorage.removeItem("IFilterInscriptions");
    localStorage.removeItem("IFilterFichierAlertePoches");
    localStorage.removeItem("ISortStore");
    localStorage.removeItem("IFilterNoticesAapraitre");
    localStorage.removeItem("activeTab");
    
    
  }, []);

   return (
    <>
        <div className="container text-center">
        <div className="row pt-5 pb-2">
          <div className="col col-12 ">
            <h2 className="titreModule titre-bleu"><i className="bi-house pe-2" />Back office {process.env.REACT_APP_WEBSITE_TITLE}</h2>
          </div>
        </div>
        <div className="row pt-3 pb-5">
          <div className="col col-md-10 offset-md-1 col-12 ">
          <div className="description">
              &nbsp;
            </div>
          </div>
      </div>
    </div>
      <Row xs={1} md={2} className="g-4">
      {/* {Array.from({ length: 4 }).map((_, idx) => ( */}
        <Col key={1}>
        <Card className="module-card-BO">
          <Card.Header className="text-start">
          <i className="bi bi-chat-left-text-fill"></i>
          </Card.Header>
          <Card.Body>
            <Card.Title>Demandes clients</Card.Title>
             <div className="description pt-2 row">
              <div className="col-3">
                <img src={img_rond} className="card-image" />
              </div>
              <div className="col-9"> 
                <ul>
                  <li>Module permettant aux CREs et QUAs de gérer toutes les demandes de modifications par messages.</li>
                </ul>
              </div>
              </div>
          </Card.Body>
          <Card.Footer>
          <Link to={`../demandes`} className="btn btn-secondary">Accéder</Link>
          </Card.Footer>
        </Card>
      </Col>
      <Col key={2}>
        <Card className="module-card-BO">
          <Card.Header className="text-start">
          <i className="bi bi-buildings-fill"></i>
          </Card.Header>
          <Card.Body>
            <Card.Title>Comptes sociétés</Card.Title>
             <div className="description pt-2 row">
              <div className="col-3">
                <img src={img_rond} className="card-image" />
              </div>
              <div className="col-9"> 
                <ul>
                  <li>Module permettant  de gérer les ouvertures de comptes éditeurs ou diffuseurs.</li>
                </ul>
              </div>
              </div>
          </Card.Body>
          <Card.Footer>
          <Link to={`../societes`} className="btn btn-secondary">Accéder</Link>
          </Card.Footer>
        </Card>
      </Col>
      <Col key={3}>
      <Card className="module-card-BO">
          <Card.Header className="text-start">
          <i className="bi bi-people-fill"></i>
          </Card.Header>
          <Card.Body>
            <Card.Title>Comptes utilisateurs</Card.Title>
             <div className="description pt-2 row">
              <div className="col-3">
                <img src={img_rond} className="card-image" />
              </div>
              <div className="col-9"> 
                <ul>
                  <li>Module permettant d&apos;accéder aux fiches des utilisateurs, qu&apos;ils soient client admin ou client utilisateur.</li>
                </ul>
              </div>
              </div>
          </Card.Body>
          <Card.Footer>
          <Link to={`../comptes`} className="btn btn-secondary">Accéder</Link>
          </Card.Footer>
        </Card>
      </Col>
      <Col key={3}>
      <Card className="module-card-BO">
          <Card.Header className="text-start">
          <i className="bi bi-people-fill"></i>
          </Card.Header>
          <Card.Body>
            <Card.Title>Demandes inscriptions</Card.Title>
             <div className="description pt-2 row">
              <div className="col-3">
                <img src={img_rond} className="card-image" />
              </div>
              <div className="col-9"> 
                <ul>
                  <li>Module permettant de traiter et valider les demandes d&apos;inscription des nouveaux éditeurs et diffuseurs souhaitant créer un compte professionnel.</li>
                </ul>
              </div>
              </div>
          </Card.Body>
          <Card.Footer>
          <Link to={`../inscriptions`} className="btn btn-secondary">Accéder</Link>
          </Card.Footer>
        </Card>
      </Col>
    </Row>
    </>
  );
};

export default PageBOAccueil;
